import type { WorkbookLayerPath } from '@disy/cadenza.js';

import { PARAMETER_LAYERS } from 'cadenza/api-client/published-api-constants';
import { getLayerId } from 'cadenza/integration/cadenza-api-layer-path';
import { getStore } from 'cadenza/store/cadenza-store';
import type { LayerId } from 'cadenza/workbook/api/layer-id';
import type { ViewId } from 'cadenza/workbook/api/view-id';

// If some layers are specified via URL query param, we restrict the selection to only those layers, otherwise all (data) layers are selectable
export function extractSelectableLayerIdsFromUrl(viewId: ViewId): LayerId[] | undefined {
  const selectableLayersParam = new URLSearchParams(location.search).get(PARAMETER_LAYERS);
  return selectableLayersParam ?
      JSON.parse(selectableLayersParam).map((name: WorkbookLayerPath) =>
        getLayerId(getStore().getState(), viewId, name),
      )
    : undefined;
}
